import styled from '@emotion/styled';
import * as carriersIcon from '~/assets/icons/icon_carrierparcel.svg';
import * as customDimsIcon from '~/assets/icons/icon_customdims.svg';
import * as parcelIcon from '~/assets/icons/parcel.svg';
import { colors, fontFamily } from '~/styles/constants';
import ParcelTemplate, {
  CarrierParcelTemplate,
  getDimensionsString,
  getName,
} from '~/types/ParcelTemplate';

const FlexWrapper = styled('div')`
  display: flex;
  align-items: center;
  margin-left: 6px;
  font-family: ${fontFamily};
`;

const OptionSelectedIcon = styled(FlexWrapper)`
  margin-right: 12px;
  padding-right: 12px;
  padding-left: 8px;
  border-right: 1px solid ${colors.gray50};
  height: 32px;

  img {
    width: 16px;
  }
`;

interface SelectButtonProps {
  initialContentString?: string;
  selectedParcel?: ParcelTemplate;
  isUsingCustomDimensions?: boolean;
  hideIcon?: boolean;
  hideDimensions?: boolean;
}

const SelectButtonContent = (props: SelectButtonProps) => {
  const {
    selectedParcel,
    isUsingCustomDimensions,
    hideIcon,
    hideDimensions,
    initialContentString,
  } = props;
  const dimensionProvider =
    selectedParcel && selectedParcel.carrierTemplate
      ? selectedParcel.carrierTemplate
      : selectedParcel;
  const carrierParcel = selectedParcel as ParcelTemplate & CarrierParcelTemplate;

  let content = '';
  let icon = parcelIcon;

  if (isUsingCustomDimensions) {
    content = 'Custom Dimensions';
    icon = customDimsIcon;
  } else if (
    selectedParcel &&
    ((carrierParcel && carrierParcel.isVariableDimensions) || // Carrier parcel template
      (selectedParcel.objectId &&
        selectedParcel.carrierTemplate &&
        selectedParcel.carrierTemplate.isVariableDimensions)) // User parcel template based on variable dimension carrier template
  ) {
    content = `${getName(selectedParcel)}`;
    if (!selectedParcel.objectId) {
      icon = carriersIcon;
    }
  } else if (selectedParcel) {
    const dimensions = getDimensionsString(dimensionProvider!);
    content = `${getName(selectedParcel)} ${
      dimensions && !hideDimensions ? `(${dimensions})` : ''
    }`;
    if (!selectedParcel.objectId) {
      icon = carriersIcon;
    }
  } else {
    content = initialContentString || 'Select Template or Enter Dimensions...';
  }

  const selectIcon =
    !hideIcon && (selectedParcel || isUsingCustomDimensions) ? (
      <OptionSelectedIcon>
        <img src={icon} alt="" />
      </OptionSelectedIcon>
    ) : null;

  return (
    <FlexWrapper>
      {selectIcon}
      {content}
    </FlexWrapper>
  );
};

export default SelectButtonContent;
